import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const JST = "Asia/Tokyo";

/**
 * 日時をJSTでフォーマットする（表示用）
 */
export function formatDateTimeJST(date: string | null): string {
  if (!date) return "-";
  return dayjs(date).tz(JST).format("YYYY-MM-DD HH:mm");
}

/**
 * 日付をJSTでフォーマットする（表示用、時刻なし）
 */
export function formatDateJST(date: string | null): string {
  if (!date) return "-";
  return dayjs(date).tz(JST).format("YYYY-MM-DD");
}

/**
 * datetime-local入力値をISO 8601（JST付き）に変換する（API送信用）
 * 入力例: "2024-01-01T09:00" → "2024-01-01T09:00:00+09:00"
 */
export function toISOStringJST(datetimeLocalValue: string): string {
  return dayjs.tz(datetimeLocalValue, JST).format();
}

/**
 * ISO 8601日時をJSTのdatetime-local形式に変換する（input[type=datetime-local]用）
 * 入力例: "2024-01-01T00:00:00.000Z" → "2024-01-01T09:00"
 */
export function toDatetimeLocalJST(isoString: string): string {
  return dayjs(isoString).tz(JST).format("YYYY-MM-DDTHH:mm");
}
